<div class="section-content" [formGroup]="parentForm">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "app.defaultSmoothingTimePeriodLabel" | translate }}</mat-label>
    <mat-select [formControl]="control" name="defaultLowPassFilter">
      @for (option of selectableLowPassFilterPeriods; track option) {
        <mat-option
          [value]="option.value"
          >
          {{ option.viewValue }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
